var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Renderer } from './Renderer';
import { Rect, Circle, Ellipse, Line, Arc, Polygon, Polyline, Path, Star, TextNode, ImageNode, } from '../shapes/index';
import { isGradient, createSvgGradient, createSvgShadowFilter } from './styles';
import { arcSectorPath } from './arcSector';
import { cssStageBackground, unwrapThemeBackgroundSrc, } from '../components/uiTheme';
var SVGRenderer = /** @class */ (function (_super) {
    __extends(SVGRenderer, _super);
    function SVGRenderer() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.nodeElements = new Map();
        _this.shapeElements = new Map();
        _this.defCounter = 0;
        _this.seenIds = new Set();
        return _this;
    }
    SVGRenderer.prototype.init = function (container, options) {
        this.width = options.width;
        this.height = options.height;
        this.background = options.background;
        this.svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        this.svg.setAttribute('width', String(this.width));
        this.svg.setAttribute('height', String(this.height));
        this.svg.setAttribute('viewBox', "0 0 ".concat(this.width, " ").concat(this.height));
        this.svg.style.display = 'block';
        this.defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        this.svg.appendChild(this.defs);
        this.sceneRoot = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        this.sceneRoot.setAttribute('data-lightdraw-scene', 'true');
        this.svg.appendChild(this.sceneRoot);
        this.syncBackgroundNode();
        container.appendChild(this.svg);
    };
    /** Update stage background (solid or image). */
    SVGRenderer.prototype.setStageBackground = function (value) {
        this.background = value;
        this.syncBackgroundNode();
        this.forceFullRedraw();
    };
    SVGRenderer.prototype.syncBackgroundNode = function () {
        this.svg.querySelectorAll('[data-lightdraw-bg], [data-lightdraw-bg-image]').forEach(function (n) { return n.remove(); });
        this.svg.style.background = '';
        if (!this.background || this.background === 'transparent')
            return;
        var src = unwrapThemeBackgroundSrc(this.background);
        if (src) {
            this.svg.style.background = cssStageBackground(this.background);
            var img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
            img.setAttribute('data-lightdraw-bg-image', 'true');
            img.setAttribute('href', src);
            img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', src);
            img.setAttribute('width', '100%');
            img.setAttribute('height', '100%');
            img.setAttribute('preserveAspectRatio', 'xMidYMid slice');
            this.svg.insertBefore(img, this.sceneRoot);
            return;
        }
        var bg = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        bg.setAttribute('data-lightdraw-bg', 'true');
        bg.setAttribute('width', '100%');
        bg.setAttribute('height', '100%');
        bg.setAttribute('fill', this.background);
        this.svg.insertBefore(bg, this.sceneRoot);
    };
    SVGRenderer.prototype.resize = function (width, height) {
        this.width = width;
        this.height = height;
        this.svg.setAttribute('width', String(width));
        this.svg.setAttribute('height', String(height));
        this.svg.setAttribute('viewBox', "0 0 ".concat(width, " ").concat(height));
        this.forceFullRedraw();
    };
    SVGRenderer.prototype.getElement = function () {
        return this.svg;
    };
    SVGRenderer.prototype.render = function (root, cameraMatrix) {
        if (cameraMatrix) {
            this.sceneRoot.setAttribute('transform', cameraMatrix.toCSS());
        }
        else {
            this.sceneRoot.removeAttribute('transform');
        }
        this.seenIds.clear();
        this.syncGroup(root, this.sceneRoot);
        this.pruneOrphans(this.sceneRoot);
        this.clearDirty();
    };
    SVGRenderer.prototype.toDataURL = function (type) {
        if (type === void 0) { type = 'image/svg+xml'; }
        var serializer = new XMLSerializer();
        var svgStr = serializer.serializeToString(this.svg);
        if (type === 'image/svg+xml') {
            return 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgStr)));
        }
        return svgStr;
    };
    SVGRenderer.prototype.destroy = function () {
        this.svg.remove();
        this.nodeElements.clear();
        this.shapeElements.clear();
    };
    SVGRenderer.prototype.syncGroup = function (group, parent) {
        var e_1, _a;
        group.sortChildren();
        try {
            for (var _b = __values(group.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                if (!child.visible)
                    continue;
                this.syncNode(child, parent);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    SVGRenderer.prototype.syncNode = function (node, parent) {
        var g = this.nodeElements.get(node.id);
        if (!g) {
            g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
            g.setAttribute('id', node.id);
            parent.appendChild(g);
            this.nodeElements.set(node.id, g);
        }
        else if (g.parentNode !== parent) {
            parent.appendChild(g);
        }
        g.setAttribute('opacity', String(node.opacity));
        g.setAttribute('transform', "translate(".concat(node.x, ",").concat(node.y, ") rotate(").concat(node.rotation, ") scale(").concat(node.scaleX, ",").concat(node.scaleY, ")"));
        if (node.shadow) {
            var filterId = this.registerShadow(node.shadow, node.id);
            g.setAttribute('filter', "url(#".concat(filterId, ")"));
        }
        else {
            g.removeAttribute('filter');
        }
        if (node.clip) {
            var clipId = this.registerClip(node, "".concat(node.id, "-clip"));
            g.setAttribute('clip-path', "url(#".concat(clipId, ")"));
        }
        else {
            g.removeAttribute('clip-path');
        }
        if (node.mask) {
            var maskId = this.registerClip(node.mask, "".concat(node.id, "-mask"));
            g.setAttribute('mask', "url(#".concat(maskId, ")"));
        }
        else {
            g.removeAttribute('mask');
        }
        node.draw(this);
        this.syncShapeElement(node, g);
        this.seenIds.add(node.id);
        if ('children' in node) {
            this.syncGroup(node, g);
        }
    };
    SVGRenderer.prototype.syncShapeElement = function (node, parent) {
        var el = this.shapeElements.get(node.id);
        if (!el) {
            var created = this.createShapeElement(node);
            if (created) {
                parent.appendChild(created);
                this.shapeElements.set(node.id, created);
            }
            return;
        }
        this.updateShapeElement(node, el);
        if (el.parentNode !== parent)
            parent.appendChild(el);
    };
    SVGRenderer.prototype.pruneOrphans = function (parent) {
        var e_2, _a, e_3, _b, e_4, _c;
        var toRemove = [];
        var childNodes = Array.from(parent.childNodes);
        try {
            for (var childNodes_1 = __values(childNodes), childNodes_1_1 = childNodes_1.next(); !childNodes_1_1.done; childNodes_1_1 = childNodes_1.next()) {
                var child = childNodes_1_1.value;
                if (child.nodeName === 'g' && child.getAttribute('id') && !this.seenIds.has(child.getAttribute('id'))) {
                    toRemove.push(child);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (childNodes_1_1 && !childNodes_1_1.done && (_a = childNodes_1.return)) _a.call(childNodes_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        try {
            for (var toRemove_1 = __values(toRemove), toRemove_1_1 = toRemove_1.next(); !toRemove_1_1.done; toRemove_1_1 = toRemove_1.next()) {
                var el = toRemove_1_1.value;
                var id = el.getAttribute('id');
                if (id) {
                    this.nodeElements.delete(id);
                    this.shapeElements.delete(id);
                }
                el.remove();
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (toRemove_1_1 && !toRemove_1_1.done && (_b = toRemove_1.return)) _b.call(toRemove_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        try {
            for (var _d = __values(Array.from(parent.childNodes)), _e = _d.next(); !_e.done; _e = _d.next()) {
                var child = _e.value;
                if (child.nodeName === 'g' && child.getAttribute('id') && this.seenIds.has(child.getAttribute('id'))) {
                    this.pruneOrphans(child);
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    SVGRenderer.prototype.registerShadow = function (shadow, nodeId) {
        var id = "shadow-".concat(nodeId, "-").concat(this.defCounter++);
        this.defs.appendChild(createSvgShadowFilter(document, id, shadow));
        return id;
    };
    SVGRenderer.prototype.registerClip = function (shapeNode, prefix) {
        var id = "".concat(prefix, "-").concat(this.defCounter++);
        var ns = 'http://www.w3.org/2000/svg';
        var clip = document.createElementNS(ns, 'clipPath');
        clip.setAttribute('id', id);
        var use = this.createShapeElement(shapeNode);
        if (use) {
            use.removeAttribute('fill');
            use.removeAttribute('stroke');
            clip.appendChild(use);
        }
        this.defs.appendChild(clip);
        return id;
    };
    SVGRenderer.prototype.registerGradient = function (fill, nodeId) {
        var id = "grad-".concat(nodeId, "-").concat(this.defCounter++);
        this.defs.appendChild(createSvgGradient(document, id, fill));
        return id;
    };
    SVGRenderer.prototype.applyStyle = function (node, elem) {
        if (node.fill) {
            if (typeof node.fill === 'string') {
                elem.setAttribute('fill', node.fill);
            }
            else if (isGradient(node.fill)) {
                var gid = this.registerGradient(node.fill, node.id);
                elem.setAttribute('fill', "url(#".concat(gid, ")"));
            }
            else {
                elem.setAttribute('fill', 'none');
            }
        }
        else {
            elem.setAttribute('fill', 'none');
        }
        if (node.stroke) {
            if (typeof node.stroke === 'string') {
                elem.setAttribute('stroke', node.stroke);
            }
            else if (isGradient(node.stroke)) {
                var gid = this.registerGradient(node.stroke, "".concat(node.id, "-s"));
                elem.setAttribute('stroke', "url(#".concat(gid, ")"));
            }
            elem.setAttribute('stroke-width', String(node.strokeWidth));
        }
        else {
            elem.removeAttribute('stroke');
        }
        if (node.dash.length > 0) {
            elem.setAttribute('stroke-dasharray', node.dash.join(' '));
        }
        else {
            elem.removeAttribute('stroke-dasharray');
        }
        if (node.dashOffset !== 0) {
            elem.setAttribute('stroke-dashoffset', String(node.dashOffset));
        }
        else {
            elem.removeAttribute('stroke-dashoffset');
        }
    };
    SVGRenderer.prototype.createShapeElement = function (node) {
        var ns = 'http://www.w3.org/2000/svg';
        var el = null;
        if (node instanceof Rect) {
            el = document.createElementNS(ns, 'rect');
            el.setAttribute('width', String(node.width));
            el.setAttribute('height', String(node.height));
            if (node.cornerRadius)
                el.setAttribute('rx', String(node.cornerRadius));
            this.applyStyle(node, el);
        }
        else if (node instanceof Circle) {
            el = document.createElementNS(ns, 'circle');
            el.setAttribute('cx', String(node.radius));
            el.setAttribute('cy', String(node.radius));
            el.setAttribute('r', String(node.radius));
            this.applyStyle(node, el);
        }
        else if (node instanceof Ellipse) {
            el = document.createElementNS(ns, 'ellipse');
            el.setAttribute('cx', String(node.radiusX));
            el.setAttribute('cy', String(node.radiusY));
            el.setAttribute('rx', String(node.radiusX));
            el.setAttribute('ry', String(node.radiusY));
            this.applyStyle(node, el);
        }
        else if (node instanceof Line) {
            el = document.createElementNS(ns, 'line');
            el.setAttribute('x1', '0');
            el.setAttribute('y1', '0');
            el.setAttribute('x2', String(node.x2));
            el.setAttribute('y2', String(node.y2));
            this.applyStyle(node, el);
        }
        else if (node instanceof TextNode) {
            el = document.createElementNS(ns, 'text');
            el.textContent = node.text;
            el.setAttribute('font-size', String(node.fontSize));
            el.setAttribute('font-family', node.fontFamily);
            if (node.fill && typeof node.fill === 'string')
                el.setAttribute('fill', node.fill);
        }
        else if (node instanceof Path) {
            el = document.createElementNS(ns, 'path');
            el.setAttribute('d', node.d);
            this.applyStyle(node, el);
        }
        else if (node instanceof Polygon) {
            el = document.createElementNS(ns, 'polygon');
            el.setAttribute('points', this.pointsAttr(node.points));
            this.applyStyle(node, el);
        }
        else if (node instanceof Polyline) {
            el = document.createElementNS(ns, 'polyline');
            el.setAttribute('points', this.pointsAttr(node.points));
            this.applyStyle(node, el);
        }
        else if (node instanceof Star) {
            el = document.createElementNS(ns, 'polygon');
            el.setAttribute('points', this.starPoints(node));
            this.applyStyle(node, el);
        }
        else if (node instanceof Arc) {
            el = document.createElementNS(ns, 'path');
            el.setAttribute('d', arcSectorPath(node.radius, node.radius, node.radius, node.startAngle, node.endAngle, node.innerRadius, node.counterClockwise));
            this.applyStyle(node, el);
        }
        else if (node instanceof ImageNode) {
            el = document.createElementNS(ns, 'image');
            el.setAttribute('href', node.src);
            el.setAttribute('width', String(node.width));
            el.setAttribute('height', String(node.height));
        }
        return el;
    };
    SVGRenderer.prototype.updateShapeElement = function (node, el) {
        if (node instanceof Rect) {
            el.setAttribute('width', String(node.width));
            el.setAttribute('height', String(node.height));
            if (node.cornerRadius)
                el.setAttribute('rx', String(node.cornerRadius));
            this.applyStyle(node, el);
        }
        else if (node instanceof Circle) {
            el.setAttribute('cx', String(node.radius));
            el.setAttribute('cy', String(node.radius));
            el.setAttribute('r', String(node.radius));
            this.applyStyle(node, el);
        }
        else if (node instanceof TextNode) {
            el.textContent = node.text;
            el.setAttribute('font-size', String(node.fontSize));
        }
        else if (node instanceof Path) {
            el.setAttribute('d', node.d);
            this.applyStyle(node, el);
        }
        else if (node instanceof Arc) {
            el.setAttribute('d', arcSectorPath(node.radius, node.radius, node.radius, node.startAngle, node.endAngle, node.innerRadius, node.counterClockwise));
            this.applyStyle(node, el);
        }
        else {
            this.applyStyle(node, el);
        }
    };
    SVGRenderer.prototype.pointsAttr = function (points) {
        var pts = [];
        for (var i = 0; i < points.length; i += 2) {
            pts.push("".concat(points[i], ",").concat(points[i + 1]));
        }
        return pts.join(' ');
    };
    SVGRenderer.prototype.starPoints = function (node) {
        var pts = [];
        for (var i = 0; i < node.numPoints * 2; i++) {
            var r = i % 2 === 0 ? node.outerRadius : node.innerRadius;
            var angle = (i * Math.PI) / node.numPoints - Math.PI / 2;
            pts.push("".concat(node.outerRadius + r * Math.cos(angle), ",").concat(node.outerRadius + r * Math.sin(angle)));
        }
        return pts.join(' ');
    };
    SVGRenderer.prototype.drawGroup = function (_group) { };
    SVGRenderer.prototype.drawRect = function (_node) { };
    SVGRenderer.prototype.drawCircle = function (_node) { };
    SVGRenderer.prototype.drawEllipse = function (_node) { };
    SVGRenderer.prototype.drawLine = function (_node) { };
    SVGRenderer.prototype.drawArc = function (_node) { };
    SVGRenderer.prototype.drawPolygon = function (_node) { };
    SVGRenderer.prototype.drawPolyline = function (_node) { };
    SVGRenderer.prototype.drawPath = function (_node) { };
    SVGRenderer.prototype.drawStar = function (_node) { };
    SVGRenderer.prototype.drawText = function (_node) { };
    SVGRenderer.prototype.drawImage = function (_node) { };
    return SVGRenderer;
}(Renderer));
export { SVGRenderer };
